module.exports = __webpack_public_path__ + "img/FF_Info_Game_14.e903a941.png";